import { Link } from "@tanstack/react-router";
import { cn } from "@/lib/utils";

// Header pill link styled for the dark MEMIC primary bar. Used in both the
// desktop nav strip and the mobile drawer — only the wrapper layout differs.
export function NavLink({
  to,
  isActive,
  onClick,
  children,
}: {
  to: string;
  isActive: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}) {
  return (
    <Link
      to={to}
      onClick={onClick}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
        isActive
          ? "bg-primary-foreground/15 text-primary-foreground"
          : "text-primary-foreground/80 hover:bg-primary-foreground/10 hover:text-primary-foreground",
      )}
    >
      {children}
    </Link>
  );
}
